import { useEffect } from 'react';
import { pick, prop } from 'js/utils/ramda.util';
import { usePrevious } from 'js/hooks/usePrevious';
import { COMMUNICATION_WIDGETS_REDUCER } from 'js/store/constants';
import { useCustomSelector, useUserSelector } from 'js/store/hooks';

import * as hooks from './hooks';

import './useInitWidgets.scss';

export const useInitWidgets = () => {
    const { lang, isLoggedIn } = useUserSelector(pick(['lang', 'isLoggedIn']));
    const prevLang = usePrevious(lang);
    const init = hooks.useInit();
    const login = hooks.useLogin();
    const logout = hooks.useLogout();
    const isLoaded = hooks.useLoadWidgets();
    const setTranslations = hooks.useSetTranslations();
    const isConnected = hooks.useSetConnection(isLoaded);
    const { enableChat, enableInbox } = hooks.useIsWidgetsEnabled();
    const wasLoggedIn = usePrevious(isLoggedIn);
    const isWidgetsAuthenticated = useCustomSelector(COMMUNICATION_WIDGETS_REDUCER, prop('isWidgetsAuthenticated'));

    useEffect(() => {
        if (isConnected) {

            enableChat && init('chat');
            enableInbox && init('inbox');
        }
    }, [isConnected, init, enableChat, enableInbox]);

    useEffect(() => {
        if (isConnected || prevLang !== lang) {

            enableChat && setTranslations('chat');
            enableInbox && setTranslations('inbox');
        }
    }, [lang, isConnected, setTranslations, enableChat, enableInbox, prevLang]);

    useEffect(() => {
        if (!isConnected) {
            return;
        }

        if (isLoggedIn && !isWidgetsAuthenticated) {
            login();
        }
    }, [isConnected, isLoggedIn, login, isWidgetsAuthenticated]);

    useEffect(() => {
        if (!isConnected) {
            return;
        }

        if (!isLoggedIn && wasLoggedIn) {
            logout();
        }
    }, [isConnected, wasLoggedIn, isLoggedIn, logout]);
};
